module.exports = __webpack_public_path__ + "static/media/veronica-on.b1a12ac0.png";